enum MODAL_MODE {
  create,
  update,
}

export default MODAL_MODE;
